
(() => {
	const source = document.querySelector('[data-a-propos-promesse-morph-source]');
	const sourceImage = source ? source.querySelector('img') : null;
	const promesse = document.querySelector('.a-propos-promesse');
	const batisseurs = document.querySelector('.lignee-batisseurs');
	const wolf = document.querySelector('.lignee-batisseurs__wolf');

	if (!source || !sourceImage || !promesse || !batisseurs || !wolf) {
		return;
	}

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return;
	}

	const style = document.createElement('style');
	style.textContent = `
		.a-propos-promesse__image.is-morph-source-hidden img {
			opacity: 0;
		}

		.a-propos-promesse__scroll-morph {
			--morph-x: 50vw;
			--morph-y: 50vh;
			--morph-width: 240px;
			--morph-opacity: 1;
			position: fixed;
			left: 0;
			top: 0;
			width: var(--morph-width);
			pointer-events: none;
			transform: translate3d(var(--morph-x), var(--morph-y), 0) translate(-50%, -50%);
			opacity: var(--morph-opacity);
			z-index: 8;
			will-change: transform, width, opacity;
		}

		.a-propos-promesse__scroll-arrow {
			display: block;
			width: 100%;
			height: auto;
			transition: opacity 0.18s linear;
		}

		.a-propos-promesse__scroll-wolf {
			position: absolute;
			left: 50%;
			top: 50%;
			width: 100%;
			height: auto;
			opacity: 0;
			filter: blur(8px);
			transform: translate(-50%, -50%) scale(0.92);
			transition: opacity 0.18s linear, filter 0.18s linear, transform 0.18s linear;
		}

		.a-propos-promesse__particle {
			--particle-x: 0px;
			--particle-y: 0px;
			--particle-scale: 0;
			--particle-opacity: 0;
			position: absolute;
			left: 50%;
			top: 50%;
			width: clamp(6px, 1.4vw, 18px);
			aspect-ratio: 1;
			background: linear-gradient(135deg, #5AB5E4, #355AA6);
			clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
			opacity: var(--particle-opacity);
			transform: translate(-50%, -50%) translate3d(var(--particle-x), var(--particle-y), 0) scale(var(--particle-scale)) rotate(45deg);
			will-change: transform, opacity;
		}

		.lignee-batisseurs__wolf {
			transition: opacity 0.18s linear;
		}

		.a-propos-promesse__scroll-morph.is-hidden {
			visibility: hidden;
		}
	`;
	document.head.appendChild(style);

	const morph = document.createElement('div');
	morph.className = 'a-propos-promesse__scroll-morph';
	morph.setAttribute('aria-hidden', 'true');

	const arrowClone = sourceImage.cloneNode(false);
	arrowClone.className = 'a-propos-promesse__scroll-arrow';
	arrowClone.removeAttribute('loading');

	const wolfClone = wolf.cloneNode(false);
	wolfClone.className = 'a-propos-promesse__scroll-wolf';
	wolfClone.removeAttribute('loading');

	morph.append(arrowClone, wolfClone);

	const particles = Array.from({ length: 18 }, (_, index) => {
		const particle = document.createElement('span');
		const angle = (index / 18) * Math.PI * 2;
		const distance = 42 + (index % 6) * 18;
		particle.className = 'a-propos-promesse__particle';
		particle.dataset.x = String(Math.cos(angle) * distance);
		particle.dataset.y = String(Math.sin(angle) * distance * 0.62);
		morph.appendChild(particle);
		return particle;
	});

	document.body.appendChild(morph);
	morph.classList.add('is-hidden');
	wolf.style.opacity = '0';

	const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
	const lerp = (start, end, progress) => start + (end - start) * progress;
	const ease = (value) => value * value * (3 - 2 * value);

	const getCenter = (element) => {
		const rect = element.getBoundingClientRect();
		return {
			x: rect.left + rect.width / 2,
			y: rect.top + rect.height / 2,
			width: rect.width,
		};
	};

	let startCenter = null;
	let hasCompleted = false;
	let hasAnimated = false;

	const update = () => {
		const sourceRect = sourceImage.getBoundingClientRect();
		const promesseRect = promesse.getBoundingClientRect();
		const batisseursRect = batisseurs.getBoundingClientRect();
		const wolfRect = wolf.getBoundingClientRect();

		const progressStart = window.innerHeight * 1.26;
		const progressEnd = window.innerHeight * 0.30;
		const progress = ease(clamp((progressStart - wolfRect.top) / (progressStart - progressEnd), 0, 1));
		const sourceVisible = promesseRect.top < window.innerHeight * 0.72 && promesseRect.bottom > 80;
		const isPastWolf = batisseursRect.top < -window.innerHeight * 0.35;
		const hasStarted = progress > 0;

		if ((!sourceVisible && !isPastWolf && !hasAnimated) || sourceRect.width <= 0 || wolfRect.width <= 0) {
			morph.classList.add('is-hidden');
			source.classList.toggle('is-morph-source-hidden', hasCompleted);
			startCenter = null;
			wolf.style.opacity = hasCompleted ? '1' : '0';
			return;
		}

		if (isPastWolf) {
			morph.classList.add('is-hidden');
			source.classList.add('is-morph-source-hidden');
			wolf.style.opacity = '1';
			return;
		}

		if (!hasStarted) {
			morph.classList.add('is-hidden');
			source.classList.remove('is-morph-source-hidden');
			startCenter = null;
			hasAnimated = false;
			hasCompleted = false;
			wolf.style.opacity = '0';
			return;
		}

		const wolfCenter = getCenter(wolf);
		startCenter = startCenter || getCenter(sourceImage);
		hasAnimated = true;
		source.classList.add('is-morph-source-hidden');
		const travelProgress = ease(clamp(progress / 1, 0, 1));
		const morphProgress = ease(clamp((travelProgress - 0.78) / 0.22, 0, 1));
		const realWolfProgress = morphProgress;
		const cloneWolfProgress = 1 - ease(clamp((morphProgress - 0.96) / 0.04, 0, 1));
		const arrowOpacity = 1 - ease(clamp((morphProgress - 0.28) / 0.72, 0, 1));
		hasCompleted = hasCompleted || morphProgress >= 0.98;

		morph.style.setProperty('--morph-x', `${lerp(startCenter.x, wolfCenter.x, travelProgress)}px`);
		morph.style.setProperty('--morph-y', `${lerp(startCenter.y, wolfCenter.y, travelProgress)}px`);
		morph.style.setProperty('--morph-width', `${lerp(sourceRect.width, wolfRect.width, morphProgress)}px`);
		morph.style.setProperty('--morph-opacity', '1');

		arrowClone.style.opacity = arrowOpacity.toFixed(3);
		arrowClone.style.filter = `blur(${(morphProgress * 2).toFixed(2)}px)`;
		wolf.style.opacity = hasCompleted ? '1' : realWolfProgress.toFixed(3);
		wolfClone.style.opacity = (morphProgress * cloneWolfProgress).toFixed(3);
		wolfClone.style.filter = `blur(${((1 - morphProgress) * 8).toFixed(2)}px)`;
		wolfClone.style.transform = `translate(-50%, -50%) scale(${(0.92 + morphProgress * 0.08).toFixed(3)})`;

		particles.forEach((particle, index) => {
			const drift = 0.65 + (index % 4) * 0.14;
			const x = Number(particle.dataset.x || 0) * morphProgress * drift;
			const y = Number(particle.dataset.y || 0) * morphProgress * drift;
			const particleOpacity = Math.sin(morphProgress * Math.PI) * 0.85;

			particle.style.setProperty('--particle-x', `${x.toFixed(2)}px`);
			particle.style.setProperty('--particle-y', `${y.toFixed(2)}px`);
			particle.style.setProperty('--particle-scale', (morphProgress * (0.65 + (index % 3) * 0.18)).toFixed(3));
			particle.style.setProperty('--particle-opacity', particleOpacity.toFixed(3));
		});

		morph.classList.toggle('is-hidden', progress >= 0.999);
	};

	let ticking = false;
	const requestUpdate = () => {
		if (ticking) {
			return;
		}

		ticking = true;
		window.requestAnimationFrame(() => {
			update();
			ticking = false;
		});
	};

	window.addEventListener('scroll', requestUpdate, { passive: true });
	window.addEventListener('resize', requestUpdate);
	window.addEventListener('load', requestUpdate);
	requestUpdate();
})();
